<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="16.971" height="16.971" viewBox="0 0 16.971 16.971">
		<g id="" data-name="Gruppe 15011" transform="translate(-338.514 -44.514)">
			<g id="" data-name="Gruppe 15009" transform="translate(4 -2)">
				<line
					id=""
					data-name="Linie 7"
					x2="20"
					transform="translate(335.929 47.929) rotate(45)"
					fill="none"
					:stroke="color"
					stroke-linecap="round"
					stroke-width="2"
				/>
			</g>
			<g id="" data-name="Gruppe 15010" transform="translate(339.93 45.929)">
				<line
					id=""
					data-name="Linie 7"
					y1="0.001"
					x2="19.999"
					transform="translate(14.142 0.001) rotate(135)"
					fill="none"
					:stroke="color"
					stroke-linecap="round"
					stroke-width="2"
				/>
			</g>
		</g>
	</svg>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
export default defineComponent({
	name: 'XIcon',
	data() {
		return {};
	},
	props: {
		color: {
			type: String,
			default: 'var(--el-color-primary)',
		},
	},
});
</script>
